export {default} from 'views/BaseSymbols/BaseSymbols'


// WEBPACK FOOTER //
// ./src/views/Administration/BaseSymbols.jsx